import React from 'react';
import styled from 'styled-components';
import { QUERY_KEYS } from '@constants';
import { fetchAllSlides } from '@services';
import { setSlideId } from '@actions/creators';
import { PAGE_URLS } from '@constants';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

const ListStyle = styled.ul`
    padding-inline-start: 10px;
    list-style-type: decimal;
    li {
        cursor: pointer;
        padding: 5px 0;
    }
`;

export const AllSlides = ({ addSlide = false, dispatch = null, handleClick = null }) => {
    const { allSlidesQuery } = QUERY_KEYS;
    const { isLoading, error, data } = useQuery(allSlidesQuery, fetchAllSlides);

    if (isLoading) return <div>Loading all slides...</div>;

    if (error) return <div>An error occurred: {error.message} </div>;

    function handleSlideClick(slide) {
        if (handleClick) {
            handleClick(slide);
        } else if (dispatch) {
            dispatch(setSlideId(slide.id));
        }
    }

    return (   
        <ListStyle>
        {
            data.map((slide) => (
                <li 
                    onClick={() =>handleSlideClick(slide)}
                    key={slide.id}>
                        {slide.name}
                </li>
            ))
        }
        {   addSlide && (
                <li>
                    <Link to={PAGE_URLS.ADD_SLIDE}>
                        Add slide
                    </Link>
                </li>
            )
        }
        </ListStyle>
    );
};

export default AllSlides;
